import Head from "next/head"

import { MetaTagsTypes } from "@/types/index"

const HeadSeo = ({ metaTags }: { metaTags: MetaTagsTypes }) => {
  const {
    title,
    description,
    image,
    url,
    breadCrumbSD,
    imageObj,
    robots,
    canonical,
  } = metaTags

  return (
    <Head>
      {/*  Facebook tags  */}
      <meta property="og:title" content={title} key="title" />
      <meta name="og:description" content={description} key="description" />
      <meta property="og:type" content="website" key="type" />
      <meta property="og:url" content={url} key="url" />
      <meta property="og:image" content={image} key="image" />
      <meta property="og:image:alt" content="Search image" key="imageAlt" />
      <meta property="og:locale" content="en_US" key="locale" />
      {/*  twitter tags  */}
      <meta
        name="twitter:card"
        content="summary_large_image"
        key="twitterCard"
      />
      <meta name="twitter:title" content={title} key="twitterTitle" />
      <meta
        name="twitter:description"
        content={description}
        key="twitterDescription"
      />
      <meta name="twitter:image" content={image} key="twitterImage" />
      {/*  standard tags  */}
      <title>{title}</title>
      <link rel="canonical" href={canonical} />
      <meta name="description" content={description} />
      <meta charSet="UTF-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1"
      />
      {robots !== "" && <meta name="robots" content={robots} key="robots" />}

      <script
        key="structured-data"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadCrumbSD) }}
      />
      <script
        key="structured-data-image"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(imageObj) }}
      />
    </Head>
  )
}

export default HeadSeo
